import React from "react";
import { connect } from "react-redux";
import { Translate, I18n } from "react-redux-i18n";
import {
  FaPaperPlane,
  FaCamera,
  FaTimes,
  FaUser,
} from "react-icons/fa";
import "./styles/WallFeed.css";
import "../pages/styles/Comments.css";
import alertify from "alertifyjs";
import "./styles/Alertify.css";
import "./styles/AlertifyTheme.css";
import "./styles/Alertify.min.css";
import "./styles/AlertifyTheme.min.css";
import * as actions from "../redux/actions/adCommentActions";
import HeadComment from "../components/HeadComment";
import CommentPostCard from "../components/CommentPostCard";
import MiniLoader from "./MiniLoader";
import ModalGalery from "../components/ModalGalery";
import { convertToWebp } from "../utils/imageUtils";

class CommentCenter extends React.Component {
  state = {
    comment_text: "",
    disabled: true,
    image: "",
    file: "",
    hasFile: false,
    loading: false,
  };

  onClickSendComment = async () => {
    if (!this.state.hasFile && this.state.comment_text === "") return;

    const parentId = this.props.commentItem?.Id || this.props.commentId;
    if (!parentId) return;

    this.setState({ loading: true });
    const params = new FormData();
    if (this.state.hasFile) {
      const webpFile = await convertToWebp(this.state.file);
      params.append("image", webpFile);
    }
    if (this.state.comment_text !== "") {
      params.append("comment", this.state.comment_text);
    }
    params.append("comment_id", parentId);
    params.append("id", this.props.user_id);

    await this.props.AddComment(this.props.token, params).then(() => {
      if (this.props.error) {
        alertify.warning(I18n.t(this.props.error));
        this.setState({ loading: false });
      } else {
        this.setState({
          comment_text: "",
          image: "",
          file: "",
          hasFile: false,
          disabled: true,
          loading: false,
        });
      }
    });
  };

  onChangeImage = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      this.setState({
        file,
        image: reader.result,
        hasFile: true,
        disabled: false,
      });
    };
    reader.readAsDataURL(file);
  };

  removeImage = () => {
    this.setState({
      file: "",
      image: "",
      hasFile: false,
      disabled: this.state.comment_text.length === 0,
    });
  };

  onChangeComment = (event) => {
    const comment = event.target.value;
    this.setState({
      comment_text: comment,
      disabled: comment.length === 0 && !this.state.hasFile,
    });
  };

  onClickUp = async (item) => {
    if (item.Like === 1) {
      await this.props.RemoveLike(this.props.token, {
        comment_id: item.Id,
        id: this.props.user_id,
        lang: I18n.t("locale"),
      });
    } else {
      await this.props.UpdateLike(this.props.token, {
        comment_id: item.Id,
        status: "1",
        id: this.props.user_id,
        lang: I18n.t("locale"),
      });
    }
  };

  onClickDown = async (item) => {
    if (item.Like === 0) {
      await this.props.RemoveLike(this.props.token, {
        comment_id: item.Id,
        id: this.props.user_id,
        lang: I18n.t("locale"),
      });
    } else {
      await this.props.UpdateLike(this.props.token, {
        comment_id: item.Id,
        status: "'0'",
        id: this.props.user_id,
      });
    }
  };

  onClickReportComment = async (item) => {
    await this.props
      .ReportComment(this.props.token, {
        comment_id: item.Id,
        id: this.props.user_id,
        lang: I18n.t("locale"),
      })
      .then(() => {
        if (!this.props.error) {
          alertify.success(I18n.t("success"));
        }
      });
  };

  onClickRemoveComment = async (item) => {
    await this.props.RemoveComment(this.props.token, {
      comment_id: item.Id,
      id: this.props.user_id,
      lang: I18n.t("locale"),
    });
  };

  onClickLoadMore = async () => {
    const parentId = this.props.commentItem?.Id || this.props.commentId;
    if (!parentId) return;

    try {
      await this.props
        .LoadCommentMore(this.props.token, {
          comment_id: parentId,
          index: this.props.pageCount,
          id: this.props.user_id,
          lang: I18n.t("locale"),
        })
        .then(() => {
          if (this.props.error) {
            alertify.warning(I18n.t(this.props.error));
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    const userAvatar = this.props.user?.avatar;
    const replies = this.props.commentList || [];

    return (
      <section className="wall-feed">
        <HeadComment commentId={this.props.commentId} />

        <div className="comment-thread-composer-wrap">
          <p className="comment-thread-composer-label">
            <Translate value="comment_thread_reply" />
          </p>
          <div className="wall-feed-composer">
          <div className="wall-feed-composer-inner">
            {userAvatar ? (
              <img
                className="wall-feed-composer-avatar"
                src={userAvatar}
                alt=""
              />
            ) : (
              <div className="wall-feed-composer-avatar">
                <FaUser />
              </div>
            )}
            <div className="wall-feed-composer-field">
              <textarea
                name="comment_msg"
                className="wall-feed-composer-textarea"
                placeholder={I18n.t("comment_placeholder")}
                value={this.state.comment_text}
                onChange={this.onChangeComment}
                disabled={this.state.loading}
              />
              {this.state.hasFile && (
                <div className="wall-feed-composer-preview">
                  <img src={this.state.image} alt="" />
                  <button
                    type="button"
                    className="wall-feed-composer-preview-remove"
                    onClick={this.removeImage}
                    aria-label="Remove image"
                  >
                    <FaTimes />
                  </button>
                </div>
              )}
              <div className="wall-feed-composer-actions">
                <div>
                  <input
                    accept="image/*"
                    id="comment_thread_attach"
                    type="file"
                    className="wall-feed-attach-input"
                    onChange={this.onChangeImage}
                  />
                  <label
                    htmlFor="comment_thread_attach"
                    className="wall-feed-tool-btn"
                  >
                    <FaCamera />
                  </label>
                </div>
                <button
                  type="button"
                  className="wall-feed-send-btn"
                  disabled={this.state.disabled || this.state.loading}
                  onClick={this.onClickSendComment}
                >
                  <FaPaperPlane />
                  <Translate value="store_reviews_send" />
                </button>
              </div>
            </div>
          </div>
        </div>
        </div>

        {this.state.loading && (
          <div className="wall-page-loading">
            <MiniLoader />
          </div>
        )}

        <section className="comment-thread-replies">
        <h2 className="comment-thread-replies-title">
          <Translate value="comments" />
          {replies.length > 0 && (
            <span className="comment-thread-replies-count">{replies.length}</span>
          )}
        </h2>

        {this.props.loadingReplies ? (
          <div className="wall-page-loading">
            <MiniLoader />
          </div>
        ) : replies.length === 0 ? (
          <div className="comment-thread-empty">
            <Translate value="comment_thread_empty" />
          </div>
        ) : (
          <div className="wall-feed-list comment-thread-replies-list">
            {replies.map((item) => (
              <div key={item.Id} className="comment-reply-card">
                <CommentPostCard
                  comment={item}
                  user_id={this.props.user_id}
                  onClickUp={() => this.onClickUp(item)}
                  onClickDown={() => this.onClickDown(item)}
                  onClickRemove={() => this.onClickRemoveComment(item)}
                  onClickReport={() => this.onClickReportComment(item)}
                />
              </div>
            ))}
          </div>
        )}

        {!this.props.loadingReplies &&
          this.props.pageSize >= 15 &&
          (this.props.loadingMore ? (
            <div className="wall-page-loading">
              <MiniLoader />
            </div>
          ) : (
            <div className="wall-feed-load-more">
              <button
                type="button"
                className="wall-feed-load-more-btn"
                onClick={this.onClickLoadMore}
              >
                <Translate value="load_more" />
              </button>
            </div>
          ))}

        <ModalGalery />
        </section>
      </section>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    user: reducer.session.auth,
    commentList: reducer.adComment.list,
    error: reducer.adComment.error,
    loading: reducer.adComment.loading,
    commentItem: reducer.adComment.item,
    loadingMore: reducer.adComment.loadingMore,
    pageSize: reducer.adComment.page_size,
    pageCount: reducer.adComment.page_count,
  };
}

const mapDispatchToProps = (dispatch) => ({
  AddComment: (token, params) =>
    dispatch(actions.addComment({ token, params })),
  RemoveLike: (token, params) =>
    dispatch(actions.removeLike({ token, params })),
  UpdateLike: (token, params) =>
    dispatch(actions.updateLike({ token, params })),
  ReportComment: (token, params) =>
    dispatch(actions.reportComment({ token, params })),
  RemoveComment: (token, params) =>
    dispatch(actions.removeComment({ token, params })),
  LoadCommentMore: (token, params) =>
    dispatch(actions.loadListScroll({ token, params })),
});

export default connect(mapStateToProps, mapDispatchToProps)(CommentCenter);
